import script from "./Main-Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Main-Navigation.vue?vue&type=style&index=0&id=7035a33f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7035a33f"]])

export default __exports__